var $ = require('jquery');

/* init domain selector */
$(document).ready(function () {
    var ds = $('.domain-selector');
    if( ds.length > 0){
        ds.domainSelector();
    }
});
